<template>
  <div class="clientpicker-wrap">
    <label class="label input__label">{{ _translate('clientSelector.search') }}</label>
  	<div class="clientpicker-input">
  		<input
         :id="id + '-search'"
         type="search"
         class="input"
  			 @keyup="checkInput">
      <ul v-if="getClientData()" class="clientpicker-list">
        <li v-for="(field, findex) in getClientData()">
          <input 
            class="clientpicker-list__input"
            :name="id + '[]'" 
            :id="setItemId(findex)" 
            :value="findex"
            type="radio"
            @change="selectClientId"
          >
          <label class="clientpicker-list__label" :for="setItemId(findex)" v-html="outputName(field, true)"></label>
        </li>
      </ul>               
  	</div>
    <div v-if="this.$data.showClients" class="clients">
      <h2 class="clients__heading">{{ _translate('clientSelector.activeClients') }}</h2>
      <ul class="full-client-list">
        <li v-for="(field, findex) in getClientList()" class="full-client-list__item">
          <input 
            class="full-client-list__input"
            :name="id + '[]'" 
            :id="setItemId(findex)" 
            :value="outputId(field)"
            type="radio"
            @change="selectClientId"
          >
          <label class="full-client-list__label" :for="setItemId(findex)" v-html="outputName(field, false)">{{ _translate('clientSelector.clientBase') }}</label>
        </li>
      </ul> 
      <h2 class="clients__heading clients__heading--inactive">{{ _translate('clientSelector.inactiveClients') }}</h2>
      <ul class="full-client-list">
        <li v-for="(field, findex) in getClientList(true)" class="full-client-list__item deactive">
          <input 
            class="full-client-list__input"
            :name="id + 'Inactive[]'" 
            :id="setItemId(outputId(field))" 
            :value="outputId(field)"
            type="radio"
            @change="selectClientId"
          >
          <label class="full-client-list__label" :for="setItemId(outputId(field))" v-html="outputName(field, false)">{{ _translate('clientSelector.clientBase') }}</label>
        </li>
      </ul>       
    </div>
    <div class="panel__control">
      <div class="panel__buttons">
        <button class="button" @click="toggleClients">{{ setAllClientsButton() }}</button>
        <button class="button" v-if="$data.showClients" @click="printClients">Print Client List</button>
        <button class="button" v-if="$data.showClients" @click="exportClients">Export Client List</button>
        <!-- https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side -->
      </div>
    </div>

  </div>
</template>

<script>

export default {

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    getClientData() {

      var data = this.$store.getters.getClientData({}),
          pattern = this.$data.pattern.trim(),
          clients = {},
          x = 0;

      if ( pattern === '' || pattern.length < 3 ) {

        return false;

      }

      for ( var key in data ) {

        var str = data[key].firstName + ' ' + data[key].lastName;

        str = str.trim().toLowerCase();

        if( data[key].deactivate !== 'true' ) {

          if ( str.indexOf(this.$data.pattern.toLowerCase(), 0) > -1 && x < 10 ) {

            clients[key] = data[key];
            x += 1;

          }

        }

      }

      if ( x === 0 ) {

        return false;

      }

      return clients;

    }, 

    selectClientId(e) {

      if ( this.context === 'client' ) {

        var request = {},
            request_uri = window.api_uri + '/api/a23jf6x002d500as/get/client/' + e.target.value;

        this.axios.get(request_uri)
          .then(response => {
          
            var client = response.data;

            this.$store.dispatch('updateClientState', client); 

            // Check if we need to load the client data
            var spouse = this.$store.getters.getClientSpouse();

            if ( spouse !== false ) {

              this.setSpouseData(spouse);

            }                     

          }, 

          response => {
           
            window.console.log(resonse.data);

          }

        );

        // Change the current view
        this.$parent.$parent.$data.view = 'base';

      }

      else if ( this.context === 'spouse') {

        this.$store.dispatch('saveField', {
          field: this.$parent.$parent.$data.subpanel.field,
          value: e.target.value,
        });

        var spouse = this.$store.getters.getClientSpouse();
        if ( spouse !== false ) {

          this.setSpouseData(spouse);

        }          

      }

      this.$data.pattern = '';
      this.$data.showClients = false;

      var target = this.id + '-search';

      document.getElementById(target).value = '';

    },

    setSpouseData(spouse = false) {

      if ( spouse !== false ) {

        var request = {},
            request_uri = window.api_uri + '/api/a23jf6x002d500as/get/client/' + spouse;

        this.axios.get(request_uri)
          .then(response => {
          
            var client = response.data;

            this.$store.dispatch('updateSpouseState', client);                   

          }, 

          response => {
           
            window.console.log(resonse.data);

          }

        );

      }

    },


    setItemId(findex) {

      return this.id + '_' + findex;

    },

  	matchesSearch(field) {

      return true;

    },

    outputName(field, obscure = false) {

      if ( obscure ) {

        var name = field.lastName + ', ' + window.obscureName(field.firstName);

      }
      else {

        var name = field.lastName + ', ' + field.firstName;

      }

      return name;

    },

    outputId(field) {

      return field.id;

    },

    checkInput(e) {

      this.$data.pattern = e.target.value;

    },

    toggleClients() {

      this.$data.showClients = (this.$data.showClients) ? false : window.confirm('Are you sure that you want to show all clients? Full names are not obfuscated.');

    },


    /**
     * METHOD: printClients()
     * @param {Object} e - The event object sent by the button click
     *
     * This method fetches the client data, then passes this data to a custom model in order to
     * generate a printable PDF, using the PDFMake JavaScript library.
     */
    printClients(e) {

      // Prevent default
      e.preventDefault();
      
      // Now we pass the arguments to the reportModel function in order to generate the model we need for 
      // our specific implementation of the report.
      var args = {};
      args.clients = this.getClientList();
      args.printLanguage = this.$store.getters.getCurrentLanguage;

      var model = window.clientsModel(args);

      // Finally, pass the reportModel object directly into the PDFMake.js library, and trigger
      // the library's open() method to force the generated PDF to open in a new window.
      window.pdfMake.createPdf(model).open()

    },

    /**
     * METHOD: exportClients()
     * @param {Object} e - The event object sent by the button click
     *
     * This method basically fetches the client data, builds out a CSV file and then
     * downloads the file using encoded Data URLs. 
     * The following articles were referenced in creating this method:
     * https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
     * https://stackoverflow.com/questions/7034754/how-to-set-a-file-name-using-window-open
     */
    exportClients(e) {

      // Prevent default
      e.preventDefault();

      // Define the rows array 
      let rows = [['Last Name', 'First Name', 'Client ID']],
          now = new Date(),
          dateString =
            now.getUTCFullYear() + "-" +
            ("0" + (now.getUTCMonth()+1)).slice(-2) + "-" +
            ("0" + now.getUTCDate()).slice(-2) + "-" +
            ("0" + now.getUTCHours()).slice(-2) + "" +
            ("0" + now.getUTCMinutes()).slice(-2) + "" +
            ("0" + now.getUTCSeconds()).slice(-2),
          fileName = 'client-export-' + dateString + '.csv';

      // Get the clients list;
      let clients = this.getClientList();

      // Loop over list and add cleints to the listing
      for ( let x = 0; x < clients.length; x++ ) {
        rows.push([
          clients[x].lastName,
          clients[x].firstName,
          clients[x].id
        ]);
      }

      // Define the rows as a CSV
      let csvContent = "data:text/csv;charset=utf-8," 
      + rows.map(e => e.join(",")).join("\n");

      // Export the CSV using the browser's window.open() function.
      var encodedUri = encodeURI(csvContent);
      // window.open(encodedUri, 'clients.csv');

      var downloadLink = document.createElement("a");
      downloadLink.href = encodedUri;
      downloadLink.download = fileName;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);      

    },

    setAllClientsButton() {

      return (this.$data.showClients) ? 'Hide All Clients' : 'Show All Clients';

    },

    getClientList(deactive = false) {

      var data    = JSON.parse( JSON.stringify(this.$store.getters.getClientData({}))),
          clients = [],
          comp    = (deactive) ? '' : 'true';

      for ( var key in data ) {

        if ( data[key].deactivate !== comp ) {
          clients.push({
            'id' : key,
            'firstName' : data[key].firstName,
            'lastName' : data[key].lastName,
            'deactivate' : data[key].deactivate,
          })
        }

      }

      clients.sort(function(a, b) {
          var textA = a.lastName;
          var textB = b.lastName;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

      return clients;

    },

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

  },

  props : [

    'id',
    'field',
    'context',

  ],

  data() {

    return {

      data: {},
      pattern: '',
      active: false,
      showClients: false,

    }

  }

}

</script>

<style lang="scss">

  .clientpicker-input {

    position: relative;
    margin-bottom: 3rem;

    input { 

      width: calc(100% - 1.5rem);

    }

  }

  .clientpicker-list {

    list-style-type: none;
    padding: 0;
    background: #33343b;
    color: #fff;

    position: absolute;
    top: calc(100% + 1rem);
    left: 0;
    right: -1.5rem;

    &::before {

      content: '';
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6px 8px 6px;
      border-color: transparent transparent #33343b transparent;

      position: absolute;
      top: -8px;
      left: 1rem;

    }    

  }

  .clientpicker-list__input,
  .full-client-list__input {

    display: none;

  }

  .clientpicker-list__label {

    display: block;
    padding: .5rem 1rem;
    font-size: .8rem;

    &:hover,
    &:focus,
    &:active {

      background-color: rgba(0, 0, 5, 0.4)

    }

    .c {

      padding: 0 1px;
    }

  }

  .full-client-list {

    list-style-type: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-wrap: wrap;

  }

  .full-client-list__item {

    width: 33.3333%;

    &.deactive {

      opacity: .6;

    }

  }

  .full-client-list__label {

    display: block;
    margin: 0 0 1rem;
    font-size: .8rem;

    &:hover {

      cursor: pointer;
      font-weight: 700;

    }

    .c {

      padding: 0 1px;
    }

  }

  .clients {

    margin-top: 3rem;

  }

  .clients__heading--inactive {

    margin-top: 3rem;

  }
   
</style>


// WEBPACK FOOTER //
// ClientPicker.vue?42ba2d70